
<div class="search-wrapper" *ngIf="mode === 'card'">
	<label class="input search">
		<a class="search-button icon-only join-right"><i class="fa fa-search"></i></a>
		<input [placeholder]="'SEARCH' | translate" [(ngModel)]="searchInput" [ngModelOptions]="{standAlone: true}" (change)="$event.stopPropagation();" (input)="onSearch()" />
	</label>
	<div class="filters">
		<bb-button [active]="!filter && !searchInput" (click)="setFilter(null)">{{ 'ALL' | translate }}</bb-button>
		<bb-button [active]="filter?.enabled === true" (click)="setFilter({enabled: true})">{{ 'ACTIVE' | translate }}</bb-button>
		<bb-button [active]="filter?.enabled === false" (click)="setFilter({enabled: false})">{{ 'INACTIVE' | translate }}</bb-button>
	</div>
</div>
<div class="prebid-systems" *ngIf="prebidService.filteredPrebidSystems && prebidParams">
	<div class="no-results" *ngIf="!haveResults">
		{{ 'NO_RESULTS_FOUND' | translate }}
	</div>
	<ng-container *ngFor="let prebidSystem of prebidService.filteredPrebidSystems; let index=index; let odd=odd; let even=even;">
		<div
			*ngIf="showSystem(prebidSystem)"
			class="prebid-system-row"
			[ngClass]="{ odd: odd, even: even }"
			[hasPublicationField]="prebidSystem.hasPublicationField || false"
			>
			<ng-container *ngIf="mode === 'card'">
				<div class="card"
					(click)="openModal(prebidSystem)"
					[class.with-logo]="typeFilter === 'adapter' || logoImages[getCode(prebidSystem)]"
					[hidden]="prebidParams[prebidSystem.code].enabled">
					<div class="hover-area">
						<span class="edit-settings">
							{{ 'EDIT_SETTINGS' | translate }}
						</span>
					</div>
					<div class="logo" *ngIf="logoImages[getCode(prebidSystem)]; else noLogo" [class.light-logo]="lightLogos.includes(getCode(prebidSystem))">
						<img [src]="'/resources/img/logos/' + logoImages[getCode(prebidSystem)]" alt="" />
					</div>
					<ng-template #noLogo>
						<div class="no-logo" *ngIf="typeFilter === 'adapter'"><i class="far fa-image"></i></div>
					</ng-template>
					<div class="label-area">
						<span class="label">
							<span *ngIf="!prebidSystem.alias">{{ prebidSystem.label}}</span>
							<span *ngIf="prebidSystem.alias">{{ prebidSystem.code }} <bb-info [contents]="'HELP.ALIASED_BIDDER' | translate: {label:prebidSystem.label, code:prebidSystem.alias}"></bb-info></span>
						</span>
					</div>
					<mat-slide-toggle [(ngModel)]="prebidParams[prebidSystem.code].enabled" (ngModelChange)="systemStatusChange(prebidSystem.code)" [ngModelOptions]="{standalone: true}" (click)="$event.stopPropagation()" (mouseover)="$event.stopPropagation()"></mat-slide-toggle>
				</div>
				<div class="config-modal" [hidden]="!openModals[prebidSystem.code]">
					<bb-modal (onClose)="closeModals()" [title]="prebidSystem.label">
						<div class="modal-inner">
							<span *ngIf="!filterParams && prebidSystem.type === 'module'" class="message info">
								{{ 'INFO.GLOBAL_PREBID_MODAL_MODULE_DEFAULTS_EXPLAINER' | translate }}
							</span>
							<span *ngIf="!filterParams && prebidSystem.type === 'adapter'" class="message info">
								{{ 'INFO.GLOBAL_PREBID_MODAL_ADAPTER_DEFAULTS_EXPLAINER' | translate }}
							</span>
							<a *ngIf="['module', 'adapter'].includes(prebidSystem.type)" target="_blank" [href]="getDocumentationUrl(prebidSystem)" class="documentation-link">
								{{ 'DOCUMENTATION' | translate }} 
								<i class="fa fa-external-link"></i>
							</a>
									
							<div [hasPublicationField]="'bidderAliasing'" *ngIf="!filterParams && ! ['config', 'analytics', 'module'].includes(prebidSystem.type)">
								<p class="divider right-align"><small>{{ "BIDDER_ALIASING" | translate }}</small></p>
								<bb-form-element class="bidder-aliasing" [label]="'BIDDER_ALIAS' | translate">
									<ng-container *ngIf="!prebidSystem.alias">
										<input
											[attr.type]="'text'"
											[placeholder]="'HELP.BIDDER_ALIASING' | translate"
											[(ngModel)]="bidderAliases[prebidSystem.code]"
										/>
										<bb-button icon="clone" (click)="createAlias(prebidParams[prebidSystem.code], prebidSystem, bidderAliases[prebidSystem.code])">
											{{ "CREATE_BIDDER_ALIAS" | translate }}
										</bb-button>
									</ng-container>
									<ng-container *ngIf="prebidSystem.alias">
										<span class="bidder-code">{{ prebidSystem.code }}</span>
										<bb-button icon="trash" (click)="deleteAlias(prebidSystem.code)">
											{{ "DELETE" | translate }}
										</bb-button>
									</ng-container>
								</bb-form-element>
								<p class="divider right-align"><small>{{ "BIDDER_CONFIGURATION" | translate }}</small></p>
							</div>
							<ng-container *ngTemplateOutlet="configFieldsTemplate; context: {prebidSystem}"></ng-container>
							<bb-button (click)="closeModals()">{{ 'DONE' | translate }}</bb-button>
						</div>
					</bb-modal>
				</div>
			</ng-container>
	
			<ng-container *ngIf="mode !== 'card'">
				<div class="system-header" [hidden]="prebidParams[prebidSystem.code].enabled">
					<div class="status-toggle">
						<bb-status [(ngModel)]="prebidParams[prebidSystem.code].enabled" [simpleMode]="true" [valueOn]="true" [valueOff]="false" [labelOn]="''" [labelOff]="''" (ngModelChange)="systemStatusChange(prebidSystem.code)"></bb-status>
					</div>
					<div class="label-area">
						<span class="label">
							<span *ngIf="!prebidSystem.alias">{{ prebidSystem.label}}</span>
							<span *ngIf="prebidSystem.alias">{{ prebidSystem.code }} <bb-info [contents]="'HELP.ALIASED_BIDDER' | translate: {label:prebidSystem.label, code:prebidSystem.alias}"></bb-info></span>
						</span>
					</div>
				</div>
				<div class="system-configuration" [hidden]="!prebidParams[prebidSystem.code].enabled">
					<h3 *ngIf="!prebidSystem.alias">{{ prebidSystem.label}}</h3>
					<h3 *ngIf="prebidSystem.alias">{{ prebidSystem.code }} <bb-info [contents]="'HELP.ALIASED_BIDDER' | translate: {label:prebidSystem.label, code:prebidSystem.alias}"></bb-info></h3>
					<div [hasPublicationField]="'bidderAliasing'" *ngIf="!filterParams && ! ['config', 'analytics', 'module'].includes(prebidSystem.type)">
						<p class="divider right-align"><small>{{ "BIDDER_ALIASING" | translate }}</small></p>
						<bb-form-element class="bidder-aliasing" [label]="'BIDDER_ALIAS' | translate">
							<ng-container *ngIf="!prebidSystem.alias">
								<input
									[attr.type]="'text'"
									[placeholder]="'HELP.BIDDER_ALIASING' | translate"
									[(ngModel)]="bidderAliases[prebidSystem.code]"
								/>
								<span class="button" (click)="createAlias(prebidParams[prebidSystem.code], prebidSystem, bidderAliases[prebidSystem.code])">
									<i class="fa fa-clone"></i>{{ "CREATE_BIDDER_ALIAS" | translate }}
								</span>
							</ng-container>
							<ng-container *ngIf="prebidSystem.alias">
								<span class="bidder-code">{{ prebidSystem.code }}</span>
								<span class="button" (click)="deleteAlias(prebidSystem.code)">
									<i class="fa fa-trash"></i>{{ "DELETE" | translate }}
								</span>
							</ng-container>
						</bb-form-element>
						<p class="divider right-align"><small>{{ "BIDDER_CONFIGURATION" | translate }}</small></p>
					</div>
					<div class="status-toggle">
						<bb-status [(ngModel)]="prebidParams[prebidSystem.code].enabled" [simpleMode]="true" [valueOn]="true" [valueOff]="false" [labelOn]="''" [labelOff]="''" (ngModelChange)="systemStatusChange(prebidSystem.code)"></bb-status>
					</div>
					<div class="prebid-system">
						<ng-container *ngTemplateOutlet="configFieldsTemplate; context: {prebidSystem}"></ng-container>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>

<ng-template #configFieldsTemplate let-prebidSystem="prebidSystem">
	<div class="dynamic-field" *ngFor="let dynamicField of prebidSystem?.dynamicFields">
		<bb-form-element [label]="dynamicField.label">
			<ng-container [ngSwitch]="dynamicField.inputType">
				<bb-check
					*ngSwitchCase="'checkbox'"
					[attr.name]="dynamicField.path"
					[checked]="dynamicField.value !== undefined ? dynamicField.value : (dynamicField.defaultValue !== undefined ? dynamicField.defaultValue : null)"
					(onChanged)="dynamicFieldChanged(dynamicField, prebidSystem.code, $event)"
				></bb-check>
				<bb-select
					*ngSwitchCase="'select'"
					[attr.name]="dynamicField.path"
					[defaultValue]="dynamicField.value !== undefined ? dynamicField.value : (dynamicField.defaultValue !== undefined ? dynamicField.defaultValue : null)"
					[options]="dynamicField.options"
					(change)="dynamicFieldChanged(dynamicField, prebidSystem.code, $event)"
				></bb-select>
				<input
					*ngSwitchCase="'json'"
					[attr.name]="dynamicField.path"
					[attr.type]="'text'"
					[placeholder]="(dynamicField.defaultValue | json) || '(No publication default set)'"
					[value]="dynamicField.value !== undefined ? (dynamicField.value | json) : null"
					(change)="dynamicFieldChanged(dynamicField, prebidSystem.code, $event)"
				/>
				<input
					*ngSwitchDefault
					[attr.name]="dynamicField.path"
					[attr.type]="dynamicField.inputType"
					[attr.step]="dynamicField.type === 'number' ? 0.01 : null"
					[placeholder]="dynamicField.defaultValue !== undefined ? dynamicField.defaultValue : '(No publication default set)'"
					[value]="dynamicField.value !== undefined ? dynamicField.value : null"
					(change)="dynamicFieldChanged(dynamicField, prebidSystem.code, $event)"
				/>
			</ng-container>
			<small *ngIf="filterParams && filterParams[prebidSystem.code] && filterParams[prebidSystem.code][dynamicField.path] !== undefined">
				{{ 'PUBLICATION_DEFAULT' | translate }}: {{ filterParams[prebidSystem.code][dynamicField.path] }}
			</small>
		</bb-form-element>
	</div>
</ng-template>
